import {cdnImage} from '@/util/cdnImage';
import {MUIContainer} from '@/components/MUI-Components';
import {BLOCKCHAIN_AI_DEVELOPMENT} from '@/util/metaData/blockchain';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import dynamic from 'next/dynamic';
import PageHead from '@/components/PageHead';
import React from 'react';

// ─── getStaticProps ─────────────────────────────────────────────────────────
export const getStaticProps = async () => {
    const {
        blockchainAiApplication,
        blockchainAiBannerBottom,
        blockchainAiBusiness,
        blockchainAiChooseBody,
        blockchainAiChooseContent,
        blockchainAiClient,
        blockchainAiDecoding,
        blockchainAiFAQ,
        blockchainAiFeature,
        blockchainAiIndustry,
        blockchainAiMobileProcess,
        blockchainAIService,
        blockchainAiStartUp
    } = await import('@/util/contents/blockchain-ai-data');

    const {everledgerCheckPoints, everledgerDynamicScreenButton} = await import('@/util/contents/blockchain-consulting-data');

    return {
        props: {
            blockchainAiApplication,
            blockchainAiBannerBottom,
            blockchainAiBusiness,
            blockchainAiChooseBody,
            blockchainAiChooseContent,
            blockchainAiClient,
            blockchainAiDecoding,
            blockchainAiFAQ,
            blockchainAiFeature,
            blockchainAiIndustry,
            blockchainAiMobileProcess,
            blockchainAIService,
            blockchainAiStartUp,
            everledgerCheckPoints,
            everledgerDynamicScreenButton
        }
    };
};

const Banner = dynamic(() => import('@/components/Ui-components/Banner'));
const DisplayImage = dynamic(() => import('@/components/Ui-components/display-image'));
const Decoding = dynamic(() => import('@/components/Ui-components/Decoding'));
const auditImg = cdnImage('Blockchain-ai-development/Blockchain-AI-Development-Services.webp');
const HelperSection = dynamic(() => import('@/components/Ui-components/helper-section'));
const LatestCTA = dynamic(() => import('@/components/Ui-components/LatestCta'));
const Platforms = dynamic(() => import('@/components/Ui-components/platforms'));
const OurServices = dynamic(() => import('@/components/Ui-components/our-services'));
const DynamicScreens = dynamic(() => import('@/components/Ui-components/Dynamic-screens'));
const eveerLedger = cdnImage('Blockchain-consuting-images/Everledger.webp');
const MobileProcess = dynamic(() => import('@/components/Ui-components/MobileProcess'));
const development = cdnImage('Blockchain-ai-development/Blockchain-AI-Solutions-Process.svg');
import Link from 'next/link';
const OurMakeChoice = dynamic(() => import('@/components/Ui-components/OurMakeChoice'));
const LetsDiscuss = dynamic(() => import('@/components/Ui-components/Lets-discuss'));
const Questions = dynamic(() => import('@/components/Ui-components/questions'));
const Testimonials = dynamic(() => import('@/components/Ui-components/Testimonials'));

// Migrated from globals.scss `.cardano-blockchain-sprill` (owner re-attributed here per Unit B3)
const cardanoBlockchainSprillSx = {right: '300px !important'} as const;

const BlockchainAi = (props: any) => {
    const {
        openForm,
        blockchainAiApplication,
        blockchainAiBannerBottom,
        blockchainAiBusiness,
        blockchainAiChooseBody,
        blockchainAiChooseContent,
        blockchainAiClient,
        blockchainAiDecoding,
        blockchainAiFAQ,
        blockchainAiFeature,
        blockchainAiIndustry,
        blockchainAiMobileProcess,
        blockchainAIService,
        blockchainAiStartUp,
        everledgerCheckPoints,
        everledgerDynamicScreenButton
    } = props;
    const everledgerData = [
        'EverLedger, a global leader in asset traceability, collaborated with Debut Infotech to create an advanced platform that ensures transparency and trust in the supply chain. Utilizing blockchain, IoT, and AI, the platform records the provenance of high-value assets, offering real-time tracking and secure, automated transactions through smart contracts.'
    ];

    return (
        <Box>
            <PageHead meta={BLOCKCHAIN_AI_DEVELOPMENT} url="/blockchain-ai-development" />
            <Banner
                priority={true}
                handleClickOpen={openForm}
                heading="Blockchain AI Development"
                subheading="Businesses struggle with data security, inefficiencies, and trust issues in AI-driven processes. Our Blockchain AI development services integrate secure, scalable, and transparent AI models with blockchain technology. Enhance automation, eliminate vulnerabilities, and drive intelligent decision-making with our tailored solutions."
                image={cdnImage('Blockchain-ai-development/Blockchain-Ai-Development.webp')}
                // bannerBackground="blockchain-ai-banner-background"
                bannerClass="multicurrency-development-banner"
                alt="Blockchain AI Development"
                button="Contact Experts Now!"
            />
            <Box className="sub-banner-wrapper sub-banner-bottom-wrapper">
                <MUIContainer>
                    <Grid container spacing={2} alignItems="center" justifyContent="space-between" className="white-label-bottom-container">
                        <Grid item md={2} lg={1.7} sm="auto" xs={12}>
                            <Typography className="banner-bottom-heading">Our Strategic Alliances</Typography>
                        </Grid>
                        {blockchainAiBannerBottom?.map((data: any, index: number) => (
                            <Grid item sm="auto" xs={6} className="sub-banner-images" key={index + 1}>
                                <Box className="images-banner-bottom">
                                    <DisplayImage src={data.src} alt={data.alt} />
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </MUIContainer>
            </Box>
            <Grid item xs={12} className="bottom-margin top-space decording-main-wrapper mobile-top-padding mobile-bottom-margin">
                <MUIContainer>
                    <Decoding
                        imageSrc={auditImg}
                        alt="Blockchain AI Development: Driving Intelligent, Secure, and Scalable Innovation"
                        heading="Blockchain AI Development: Driving Intelligent, Secure, and Scalable Innovation"
                        subHeading={blockchainAiDecoding}
                        isSocialMediaBtn={true}
                        className="sto-development-decoding-wrap"
                    />
                </MUIContainer>
            </Grid>
            <Grid item xs={12} className="helper-section helper_section_parent">
                <Box className=" bottom-spacing top-space mobile-top-padding mobile-bottom-padding">
                    <MUIContainer>
                        <Box className="spectrum-header-wrapper solutions">
                            <Typography className="spectrum-heading color-black our-service-main-heading text-align-left" component="h2">
                                Blockchain AI Development Services for Secure and Intelligent Enterprises
                            </Typography>
                            <Box className="divder-wrapper">
                                <hr className="divider-line divider-line-left" />
                            </Box>
                            <Box className="sub-heading-box" pb={4}>
                                <Typography className="spectrum-sub-heading color-black spacing">
                                    Our Blockchain AI Development Services empower businesses to enhance automation, security, and
                                    decision-making. By integrating blockchain for artificial intelligence, we develop scalable solutions
                                    that ensure data integrity, transparency, and efficiency. From AI-driven automation to decentralized
                                    machine learning, we help enterprises harness blockchain’s potential to drive innovation and operational
                                    excellence.
                                </Typography>
                            </Box>
                        </Box>
                        <Grid container spacing={2}>
                            <HelperSection data={blockchainAIService} className="home-helper-card" />
                        </Grid>
                    </MUIContainer>
                </Box>
            </Grid>
            <Box className="bottom-spacing  mobile-bottom-padding top-space mobile-top-padding">
                <LatestCTA
                    heading="Unsure How AI Can Address Your Business Challenges and Improve Productivity?"
                    buttonText="Discover the Right AI Strategy"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Grid item xs={12} className="blockchain-revolution-service bottom-spacing  mobile-bottom-padding">
                <MUIContainer>
                    <Platforms
                        data={blockchainAiFeature}
                        heading="Exclusive Features of Blockchain AI Solutions for Secure and Intelligent Operations"
                        subheading="Our Blockchain AI solutions integrate security, automation, and transparency, ensuring seamless enterprise operations. By combining blockchain and AI, we enhance data integrity, decision-making, and system efficiency while helping businesses navigate the evolving blockchain AI market with advanced solutions."
                        containerClass="blockchain-card-container"
                        className="platform-key-industry-service no-border"
                    />
                </MUIContainer>
            </Grid>
            <Grid item xs={12} className="helper-section">
                <Box className="helper_section_parent bottom-spacing top-space mobile-top-padding">
                    <Grid container spacing={2} className="our-service-defi-wrapper">
                        <OurServices
                            ourServices={blockchainAiBusiness}
                            className="service-shadow-border-box enterprise-key-card"
                            containerClass="card-heading-spacing"
                            heading="Strategic Business Benefits of Blockchain AI for Secure and Scalable Growth"
                            subheading="Blockchain and AI are revolutionizing enterprise operations by ensuring data security, automating workflows, and enhancing decision-making. Designed for seamless integration, our Blockchain AI solutions bring transparency, efficiency, and intelligence to businesses, helping them scale with confidence in a data-driven economy."
                        />
                    </Grid>
                </Box>
            </Grid>
            <Box className="bottom-spacing  mobile-bottom-padding top-space mobile-top-padding">
                <LatestCTA
                    heading="Looking for a Scalable and Secure Blockchain AI Integration Strategy for Your Business?"
                    buttonText="Book Free Consultation"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Grid item xs={12} className="dynmaic-white-label-wrapper dynamic-bep20-wrapper">
                <MUIContainer>
                    <Box className="spectrum-header-wrapper solutions">
                        <Typography className="spectrum-heading color-black " component="h2">
                            PORTFOLIO
                        </Typography>
                        <Box className="divder-wrapper">
                            <hr className="divider-line" />
                        </Box>
                    </Box>
                    <DynamicScreens
                        imageSrc={eveerLedger}
                        subHeading="<a target='_blank' href='/case-study/everledger'>Everledger</a>"
                        heading="A Blockchain-Based Asset Provenance and Traceability Platform"
                        subPoints={everledgerData}
                        reverseOrder={true}
                        alt="Everledger"
                        checkItems={everledgerCheckPoints}
                        openForm={() => globalThis.open('/case-study/everledger', '_blank')}
                        buttonData={everledgerDynamicScreenButton}
                        buttonLabel="View Case Study"
                        buttonClass="nft-button"
                    />
                </MUIContainer>
            </Grid>
            <Grid item xs={12} className="">
                <Box className="renowed-client-wrapper bottom-spacing mobile-top-padding mobile-bottom-padding top-space helper_section_parent">
                    <MUIContainer>
                        <Box>
                            <Box className="spectrum-header-wrapper  solutions">
                                <Typography className="spectrum-heading top-space color-black ">
                                    Launch a Blockchain AI Startup Inspired by Leading Innovations
                                </Typography>
                                <Box className="divder-wrapper">
                                    <hr className="divider-line" />
                                </Box>
                                <Typography className="spectrum-sub-heading color-black spacing">
                                    Thinking about launching your own Blockchain AI startup but unsure how to shape your vision? Exploring
                                    pioneering projects can offer valuable insights into market trends, business models, and technical
                                    innovations. Whether you aim to enhance data privacy, decentralized AI, or secure automation, studying
                                    these successful platforms can help you refine your strategy.
                                </Typography>
                                <Grid container className="our-reowned-icon-wrapper defi-reowned-icon-wrapper top-spacing" spacing={2}>
                                    {blockchainAiStartUp?.map((data: any, index: number) => (
                                        <Grid item key={index + 1} md={3} sm={6} xs={12}>
                                            {data.redirect !== '' ? (
                                                <Link target="_blank" href={data.redirect}>
                                                    <DisplayImage src={data.src} alt={data.alt} className="helper-card-icon" />
                                                </Link>
                                            ) : (
                                                <DisplayImage src={data.src} alt={data.alt} className="helper-card-icon" />
                                            )}
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        </Box>
                    </MUIContainer>
                </Box>
            </Grid>
            <Box className="bottom-spacing  mobile-bottom-padding top-space mobile-top-padding">
                <LatestCTA
                    heading="Need AI Models That Ensure Data Integrity, Security, and Transparent Decision-Making?"
                    buttonText="Talk to Our Specialists"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Grid item xs={12} className="blockchain-revolution-service bottom-spacing  mobile-bottom-padding">
                <MUIContainer>
                    <Platforms
                        data={blockchainAiIndustry}
                        heading="Transforming Industries with Secure and Scalable Blockchain AI Solutions"
                        subheading="As a leading Blockchain <a target='_blank' href='/ai-development-company'>AI development company</a>, we empower industries with intelligent, secure, and automated solutions. By combining blockchain and AI, we enhance data integrity, streamline workflows, and optimize decision-making across critical sectors. Our tailored solutions integrate seamlessly with enterprise systems, ensuring transparency, efficiency, and scalability in an evolving digital economy."
                        containerClass="blockchain-card-container"
                        className="platform-key-industry-service no-border"
                    />
                </MUIContainer>
            </Grid>
            <Grid
                item
                xs={12}
                className="blockchain-revolution-service bottom-spacing mobile-top-padding mobile-bottom-padding top-space helper_section_parent"
            >
                <MUIContainer>
                    <Platforms
                        data={blockchainAiApplication}
                        heading="Real-World Applications of Blockchain AI Solutions"
                        subheading="Blockchain and AI together are driving transformative change across industries, offering security, efficiency, and automation at scale. Businesses can leverage these technologies to enhance data integrity, optimize decision-making, and unlock new revenue opportunities. Our expertise in Blockchain AI development enables enterprises to build intelligent, transparent, and future-ready solutions tailored to their industry needs."
                        containerClass="blockchain-card-container"
                        className="platform-key-industry-service no-border"
                    />
                </MUIContainer>
            </Grid>
            <Box className="bottom-spacing  mobile-bottom-padding top-space mobile-top-padding">
                <LatestCTA
                    heading="Curious About How Blockchain AI Can Optimize Industry-Specific Business Processes?"
                    buttonText="Learn More Today"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Box className="bottom-spacing process-mobile-bottom-padding">
                <MUIContainer>
                    <Box className="spectrum-header-wrapper solutions">
                        <Typography className="spectrum-heading color-black text-align-left" component="h2">
                            Our Process for Building Secure and Scalable Blockchain AI Solutions
                        </Typography>
                        <Box className="divder-wrapper">
                            <hr className="divider-line divider-line-left" />
                        </Box>
                        <Box className="sub-heading-box" pb={4}>
                            <Typography className="spectrum-sub-heading color-black spacing text-align-left" component="p">
                                As a trusted Blockchain AI development company, we follow a structured process to build secure, scalable,
                                and intelligent solutions that enhance business efficiency. By integrating blockchain and AI, we develop
                                automated, transparent, and high-performance systems tailored to industry needs. Our approach ensures data
                                integrity, process optimization, and long-term adaptability for evolving business challenges.
                            </Typography>
                        </Box>
                    </Box>
                    <Box textAlign="center">
                        <DisplayImage
                            src={development}
                            alt="Scalable Blockchain AI Solutions"
                            className="approach-main-img approach-web-img"
                        />
                    </Box>
                    <Box className="approach-main-img approach-mobile-img">
                        <MobileProcess mobileProcess={blockchainAiMobileProcess} />
                    </Box>
                </MUIContainer>
            </Box>
            <OurMakeChoice
                heading="Why Choose Debut Infotech"
                subheading="as Your Blockchain AI Development Company?"
                body={blockchainAiChooseBody}
                contentData={blockchainAiChooseContent}
            />
            <Grid item xs={12} className="bottom-spacing">
                <LetsDiscuss
                    heading="Ready to Enhance Security and Intelligence in Your Business?"
                    subheading="Optimize operations with Blockchain AI solutions that ensure data integrity, automate processes and drive smarter decision-making for long-term efficiency and scalability."
                    btnLabel="Contact Our Experts Now"
                    imageSx={cardanoBlockchainSprillSx}
                    openForm={() => {
                        globalThis.open('/contact-us', '_blank');
                    }}
                />
            </Grid>
            <Grid item xs={12} className="question-parent top-space mobile-top-padding">
                <MUIContainer>
                    <Questions accordianData={blockchainAiFAQ} subpart={true} />
                </MUIContainer>
            </Grid>
            <Grid item xs={12}>
                <Box className="top-space mobile-top-padding bg-blue-background">
                    <Testimonials heading="Client Testimonials" clientData={blockchainAiClient} />
                </Box>
            </Grid>
            <script
                type="application/ld+json"
                id="blockchain-ai-development"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'FAQPage',
                        mainEntity: [
                            {
                                '@type': 'Question',
                                name: 'How can blockchain improve AI security?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `Blockchain significantly enhances AI security by providing immutable data storage, decentralization, and cryptographic verification. AI systems process vast amounts of sensitive data, making them prone to cyber threats. Blockchain for artificial intelligence ensures that AI-generated data remains tamper-proof and secure from unauthorized modifications. Here’s how blockchain strengthens AI security:
Tamper-Proof Data Storage – AI-generated data is stored on an immutable blockchain, ensuring data integrity.
Decentralized AI Processing – Reduces single points of failure, protecting against cyberattacks.
Access Control and Audits – Smart contracts and cryptographic verification restrict unauthorized access and allow traceable transactions.
Improved AI Model Training – Secure, verified datasets ensure AI models learn from reliable sources without manipulation.`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'What are the benefits of AI and blockchain for businesses?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `The combination of blockchain and AI allows businesses to automate complex processes, enhance data security, and ensure transparent decision-making. As industries rely on AI to process large datasets, blockchain provides a secure framework for managing AI-driven operations. The benefits of this integration include:
Data Transparency & Trust – Blockchain ensures AI decisions are auditable and free from bias.
Cost Optimization – AI-driven automation reduces operational costs while blockchain eliminates intermediaries.
Fraud Prevention – AI algorithms detect fraud, while blockchain ensures real-time transaction verification.
Scalability & Performance – AI optimizes blockchain operations, making data processing faster and more efficient.
Enhanced Compliance – Businesses stay compliant by securing sensitive data with blockchain AI integration.`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How does AI-powered blockchain enhance automation?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `Businesses often struggle with inefficiencies in manual workflows, making automation crucial for scalability. AI-powered blockchain solutions streamline operations by integrating AI models with smart contracts and decentralized networks, ensuring efficiency and security. AI-driven automation in Blockchain Development Services enhances:
Self-Executing Smart Contracts – AI-enhanced contracts automate workflows, ensuring secure, real-time execution.
Predictive Maintenance – AI analyzes blockchain-stored data to detect risks and prevent operational failures.
Autonomous Decision-Making – AI learns from blockchain-verified records, enabling businesses to make data-driven decisions faster.
Supply Chain Optimization – AI-powered blockchain tracks inventory in real time, reducing inefficiencies.`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'What industries use blockchain AI solutions?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `The blockchain AI market is rapidly evolving, with multiple industries leveraging its potential for security, automation, and efficiency. Businesses across different sectors are adopting AI and blockchain integration for enhanced decision-making and operational improvements. The industries benefiting most include:
Finance – Fraud detection, risk management, and automated trading.
Healthcare – Securing medical records and AI-assisted diagnostics.
Supply Chain – Real-time tracking and transparent logistics.
E-commerce – Personalized customer experiences and automated transactions.
Cybersecurity – AI-driven threat detection and decentralized identity management.`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How do AI and blockchain work together?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `Understanding how AI and blockchain work together is essential for businesses seeking intelligent automation and secure data processing. AI enables real-time decision-making, while blockchain ensures data authenticity and decentralization. Their synergy includes:
AI enhances blockchain scalability by reducing processing time and improving efficiency.
Blockchain ensures trust in AI decisions by providing tamper-proof, auditable data.
AI-driven smart contracts automate business agreements with real-time validation.
Decentralized AI models eliminate data silos, improving security and interoperability across enterprise networks.`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How blockchain and AI are related in enterprise applications?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `Blockchain and AI are related in enterprise applications as they address data security, automation, and decision-making challenges. AI processes massive datasets, while blockchain ensures data integrity and compliance. This relationship enables:
Tamper-Proof AI Decisions – Blockchain verifies AI outputs, reducing bias.
Securing Data with Blockchain and AI – Protects sensitive enterprise data from cyber threats.
Intelligent Automation – AI-powered smart contracts streamline enterprise workflows.
Regulatory Compliance – Blockchain ensures AI models meet industry-specific data security requirements.`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How can AI-driven smart contracts help my business?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `Many businesses rely on contracts for agreements, yet manual contract processing often leads to delays and human errors. AI-driven smart contracts automate and secure transactions, ensuring seamless execution without intermediaries. This helps businesses with:
Automated Compliance – AI ensures contracts meet regulatory standards before execution.
Fraud Detection – AI algorithms analyze transaction patterns to detect anomalies in blockchain-based agreements.
Error-Free Transactions – AI validates contract conditions, preventing misinterpretation or manual errors.
Scalability – AI-powered smart contracts adapt to business growth without requiring constant modifications.`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'What is the future of the blockchain AI market?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `The blockchain AI market is expanding rapidly as businesses recognize the potential of combining decentralized security with intelligent automation. The growing demand for AI-driven blockchain solutions is driving several trends, including:
Decentralized AI Networks – Reducing reliance on centralized data control.
AI-Optimized Blockchains – Improving transaction speed and lowering computational costs.
Cross-Industry Adoption – More businesses in finance, healthcare, and cybersecurity are implementing blockchain AI.
Enhanced Data Monetization – Companies are leveraging blockchain to securely share and sell AI-generated data.`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How does blockchain help in securing AI data?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `AI systems process large volumes of sensitive data, making security a top concern for enterprises. Securing data with blockchain and AI ensures that business-critical information is protected from unauthorized access and cyber threats. Blockchain secures AI data through:
Ensuring Data Immutability – Preventing unauthorized modifications to AI-generated records.
Decentralized Access Control – Eliminating single-point vulnerabilities in AI data storage.
Smart Contract Encryption – Restricting AI models to verified, blockchain-stored data.
Real-Time Data Authentication – Allowing AI to cross-check blockchain-stored data before making decisions.`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Where to hire AI developers for blockchain projects?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `Finding the right talent is crucial for businesses seeking to build AI and blockchain integration solutions. Skilled developers must have expertise in AI frameworks, AI algorithms, and Blockchain Development Services. Companies can hire AI developers from trusted firms like Debut Infotech, which offers:
Custom AI Blockchain Development – Tailored solutions for enterprise automation and security.
Industry-Specific Expertise – AI-powered blockchain solutions for finance, healthcare, and cybersecurity.
Seamless AI Model Integration – Helping businesses optimize AI-driven blockchain platforms.`
                                }
                            }
                        ]
                    })
                }}
            />
        </Box>
    );
};

export default BlockchainAi;
BlockchainAi.Layout = 'Main';
